import { useCallback, useEffect, useState } from 'react';
import { getParkingQueueConfig, saveParkingQueueConfig } from '../../api/parkingQueueConfigApi';
import { DEFAULT_PARKING_QUEUE_CONFIG, ParkingQueueConfig } from '../../types/parkingQueueConfig';

export interface UseParkingQueueConfigReturn {
    config: ParkingQueueConfig;
    loading: boolean;
    saving: boolean;
    error: string | null;
    save: (config: ParkingQueueConfig) => Promise<void>;
}

/** The queue order config (session-cached by the API) and its admin save. */
export const useParkingQueueConfig = (): UseParkingQueueConfigReturn => {
    const [config, setConfig] = useState<ParkingQueueConfig>(DEFAULT_PARKING_QUEUE_CONFIG);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        getParkingQueueConfig()
            .then(c => { if (!cancelled) setConfig(c); })
            .catch(e => { console.error(e); if (!cancelled) setError('Kunde inte läsa köordningen'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);

    const save = useCallback(async (next: ParkingQueueConfig) => {
        setSaving(true);
        setError(null);
        try {
            await saveParkingQueueConfig(next);
            setConfig(next);
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Kunde inte spara köordningen');
            throw e;
        } finally {
            setSaving(false);
        }
    }, []);

    return { config, loading, saving, error, save };
};
